import { DBConfig } from 'ngx-indexed-db';

export const dbConfig: DBConfig = {
    name: 'MyAppDB',
    version: 1,
    objectStoresMeta: [

        // 1. Top‑level products store
        {
            store: 'products',
            storeConfig: { keyPath: 'id', autoIncrement: false },
            storeSchema: [
                { name: 'code', keypath: 'code', options: { unique: false } },
                { name: 'nameAr', keypath: 'nameAr', options: { unique: false } },
                { name: 'nameEn', keypath: 'nameEn', options: { unique: false } },
                { name: 'baseUnitId', keypath: 'baseUnitId', options: { unique: false } },
                { name: 'descriptionAr', keypath: 'descriptionAr', options: { unique: false } },
                { name: 'descriptionEn', keypath: 'descriptionEn', options: { unique: false } },
                { name: 'productType', keypath: 'productType', options: { unique: false } },
                { name: 'groupId', keypath: 'groupId', options: { unique: false } },
                { name: 'taxCategoryId', keypath: 'taxCategoryId', options: { unique: false } },
                { name: 'taxExceptionReasonId', keypath: 'taxExceptionReasonId', options: { unique: false } },
                { name: 'exciseTaxCategoryId', keypath: 'exciseTaxCategoryId', options: { unique: false } },
                { name: 'initialCost', keypath: 'initialCost', options: { unique: false } },
                { name: 'openingStock', keypath: 'openingStock', options: { unique: false } },
                { name: 'discountRate', keypath: 'discountRate', options: { unique: false } },
                { name: 'isActiveForSales', keypath: 'isActiveForSales', options: { unique: false } },
                { name: 'allowSalesWithoutQuantity', keypath: 'allowSalesWithoutQuantity', options: { unique: false } },
                { name: 'allowSellingLessThanCost', keypath: 'allowSellingLessThanCost', options: { unique: false } },
                { name: 'reOrderLimit', keypath: 'reOrderLimit', options: { unique: false } },
                { name: 'costAccountId', keypath: 'costAccountId', options: { unique: false } },
                { name: 'revenueAccountId', keypath: 'revenueAccountId', options: { unique: false } },
                { name: 'inventoryAccountId', keypath: 'inventoryAccountId', options: { unique: false } },
                { name: 'discountAccountId', keypath: 'discountAccountId', options: { unique: false } },
                { name: 'createdBy', keypath: 'createdBy', options: { unique: false } },
                { name: 'createdOn', keypath: 'createdOn', options: { unique: false } },
                { name: 'lastModifiedBy', keypath: 'lastModifiedBy', options: { unique: false } },
                { name: 'lastModifiedOn', keypath: 'lastModifiedOn', options: { unique: false } },
                { name: 'deletedOn', keypath: 'deletedOn', options: { unique: false } },
                { name: 'deletedBy', keypath: 'deletedBy', options: { unique: false } }
            ]
        },

        // 2. productUnits store
        {
            store: 'productUnits',
            storeConfig: { keyPath: 'id', autoIncrement: false },
            storeSchema: [
                { name: 'productId', keypath: 'productId', options: { unique: false } },
                { name: 'unitId', keypath: 'unitId', options: { unique: false } },
                { name: 'size', keypath: 'size', options: { unique: false } },
                { name: 'barcode', keypath: 'barcode', options: { unique: false } }
            ]
        },

        // 3. productPrices store
        {
            store: 'productPrices',
            storeConfig: { keyPath: 'id', autoIncrement: false },
            storeSchema: [
                { name: 'productUnitId', keypath: 'productUnitId', options: { unique: false } },
                { name: 'priceLevelId', keypath: 'priceLevelId', options: { unique: false } },
                { name: 'price', keypath: 'price', options: { unique: false } },
                { name: 'branchId', keypath: 'branchId', options: { unique: false } }
            ]
        }
    ]
};